// https://meticulous.ai/blog/safer-exhaustive-switch-statements-in-typescript/
export default (_value: never): never => {
  throw new Error(`ERROR! Reached forbidden guard function with unexpected value: ${JSON.stringify(_value)}`)
}
